import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const ProtectedRoute = ({ children, requireAuth = true, redirectTo = '/login' }) => {
  const { user, isTokenValid, validateToken } = useAuth();
  const navigate = useNavigate();
  const [isChecking, setIsChecking] = useState(true);

  useEffect(() => {
    const checkAuth = async () => {
      if (requireAuth) {
        // 检查是否有用户信息和有效token
        if (!user || !isTokenValid) {
          // 尝试验证token
          const isValid = await validateToken();
          if (!isValid) {
            console.log('用户未登录或token已过期，重定向到登录页');
            navigate(redirectTo, { replace: true });
            return;
          }
        }
      }
      setIsChecking(false);
    };

    checkAuth();
  }, [user, isTokenValid, requireAuth, navigate, redirectTo, validateToken]);

  // 显示加载状态
  if (isChecking) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '200px',
        fontSize: '16px',
        color: '#666'
      }}>
        验证登录状态...
      </div>
    );
  }

  // 如果需要登录但用户未登录，不渲染子组件（已经重定向）
  if (requireAuth && (!user || !isTokenValid)) {
    return null;
  }

  return children;
};

export default ProtectedRoute; 